export var wrapper = 'relative';
export var icon = ' transition-all h-6 w-6 text-white';
export var text = 'px-2';
export var iconToggle = function (isScrolling) {
    var show = ' opacity-100 w-5 h-5 mx-1';
    var hide = ' opacity-0 w-0 h-0 mx-0';
    return icon + (isScrolling ? show : hide);
};
export var textToggle = function (isScrolling) {
    var show = ' opacity-100 w-full h-5 mx-1';
    var hide = ' opacity-0 w-0 h-0 mx-0';
    return icon + (isScrolling ? hide : show);
};
//# sourceMappingURL=fad-button.styles.js.map